import { Stack, Text, textVariants } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { SHOW_FARE_RULES } from '../../constants/general';
import { useOrderDetails } from '../../containers/OrderDetailsContext';
import type { SnowplowEventDataType } from '../../models';
import FareRulesDrawerContent from './FareRulesDrawerContent';
import CaretButtonWithDrawer from './CaretButtonWithDrawer';

interface FareRulesDrawerButtonProps {
  snowplow: SnowplowEventDataType;
}

const FareRulesDrawerButton = ({ snowplow }: FareRulesDrawerButtonProps) => {
  const { t } = useTranslation();
  const { fareRules, fareRulesExtraInfo } = useOrderDetails();

  return (
    <CaretButtonWithDrawer
      dataTestId="fare-rules-button"
      drawerContent={
        <FareRulesDrawerContent
          fareRules={fareRules}
          fareRulesDescription={fareRulesExtraInfo?.fareRulesDescription}
        />
      }
      drawerTitle={t('OrderDetails.FareRules.Button.Text')}
      queryParam={SHOW_FARE_RULES}
      snowplow={{
        category: snowplow.category,
        label: snowplow.label,
        property: snowplow.property,
      }}
    >
      <Stack align="start" spacing={4}>
        <Text variant={textVariants._16_BOLD}>{t('OrderDetails.FareRules.Button.Text')}</Text>
        <Text>{t('ManageTrip.CancellationRules.Description')}</Text>
      </Stack>
    </CaretButtonWithDrawer>
  );
};

export default FareRulesDrawerButton;
